import { type ReactNode, type JSX } from 'react'
import { Outlet } from 'react-router'

interface AdminListScreenLayoutProps {
  children?: ReactNode
}

export default function AdminListScreenLayout({
  children,
}: AdminListScreenLayoutProps): JSX.Element {
  return (
    <div className="h-screen bg-gray-50 font-sans text-sm">
      {children || <Outlet />}
    </div>
  )
}
